import { PropTypes } from 'prop-types';

import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Typography } from '@mui/material';

const ModalConfirmComponent = ({ onModalClose, onConfirmModal }) => (
  <Box display="flex" flexDirection="column" alignItems="center" p="3rem">
    <CancelIcon sx={{ fontSize: 70 }} color="error" />
    <Typography variant="h5">Are you sure?</Typography>
    <Typography variant="h6" pt={2}>
      Do you really want to stop the process?
    </Typography>
    <Box display="flex" justifyContent="space-around" width="50%" mt="1rem">
      <Button
        variant="contained"
        disableElevation
        onClick={onModalClose}
        sx={(theme) => ({
          width: '10rem',
          backgroundColor: theme.palette.secondary.main,
        })}
      >
        Stop
      </Button>
      <Button
        variant="contained"
        disableElevation
        onClick={onConfirmModal}
        sx={(theme) => ({
          width: '10rem',
          backgroundColor: theme.palette.text.primary,
        })}
      >
        Cancel
      </Button>
    </Box>
  </Box>
);

ModalConfirmComponent.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  onConfirmModal: PropTypes.func.isRequired,
};

export default ModalConfirmComponent;
